"use client";

import { useTina, tinaField } from "@/lib/utils";
import Section from "@/components/Section";
import Markdown from "@/components/Markdown";

export default function LegalPage(props) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const { title, body } = data.legal;
  return (
    <div>
      <Section
        as="header"
        className="flex items-center justify-center min-h-[200px]"
      >
        <h1 data-tina-field={tinaField(data.legal, "title")}>{title}</h1>
      </Section>
      <Section className="prose max-w-none">
        <Markdown content={body} />
      </Section>
    </div>
  );
}
